PasswordMgr = {};

var errorsType = {
    pwdEmpty: true,
    minMaxMismatch: true,
    patternNotValid: true,
    invalidCharPresent: null
}

var passwordConfig = {
    minLength: 10,
    maxLength: 30,
    minUpperCase: 1,
    minLowerCase: 1,
    minNumber: 1,
    minSpecialChr: 1
}
var lowerCaseLetters = /[a-zäöüß]/g;
var upperCaseLetters = /[A-ZßÄÖÜ]/g;
var numbers = /[0-9]/g;
var specialChr = /[#@$!%?{*}&;+\-_=§()°\/]/g;

const allowedCharRegex = new RegExp( '[a-zäöüßA-ZÄÖÜ0-9#@$!%?{*}&;+\\\/\\-_=§()°]+', 'g' );

var pwdField;

PasswordMgr.init = function () {
    pwdField = $("#password")
}

PasswordMgr.passwordShowToggle = function ( fieldId, iconId) {
    var passwordField = $(fieldId);
    var passwordIcon = $(iconId);

    if (passwordField.length > 0) {
        if (passwordField.attr("type") === 'password') {
            passwordField.attr("type", "text");
            passwordIcon.text("eye_slash");
        } else {
            passwordField.attr("type", "password");
            passwordIcon.text("eye");
        }
    }
}

PasswordMgr.execute = function () {
};

PasswordMgr.restart = function () {

    var passwordValidationLength = document.getElementById( 'password-length-block');
    var passwordValidationChr = document.getElementById('password-chr-block');
    var passwordValidationLengthIcon = $('#password-length-icon');
    var passwordValidationChrIcon = $('#password-chr-icon');
    var password_error_msg = $("#password-error-msg");

    errorsType.invalidCharPresent = null
    errorsType.minMaxMismatch = true
    errorsType.patternNotValid = true
    errorsType.pwdEmpty = true;

    passwordValidationLength.classList.remove("fro-password-policy__block--success");
    passwordValidationLengthIcon.text("xmark");
    passwordValidationChr.classList.remove("fro-password-policy__block--success");
    passwordValidationChrIcon.text("xmark");
    password_error_msg.hide();
}

/**
 * This looks terrible as it is, putting the validation on the over variables bad
 * */
PasswordMgr.greenFlags = function () {

    var passwordValidationLength = document.getElementById( 'password-length-block');
    var passwordValidationChr = document.getElementById('password-chr-block');
    var passwordValidationLengthIcon = $('#password-length-icon');
    var passwordValidationChrIcon = $('#password-chr-icon');
    if (!errorsType.minMaxMismatch){
        passwordValidationLength.classList.add("fro-password-policy__block--success");
        passwordValidationLengthIcon.text("check");
    }
    if (!errorsType.patternNotValid && errorsType.invalidCharPresent == null) {
        passwordValidationChr.classList.add("fro-password-policy__block--success");
        passwordValidationChrIcon.text("check");
    }
}

/**
 * calculate the validation results
 */
PasswordMgr.validate = function ()  {

    var valid = true;

    var passwordValidationLength = document.getElementById( 'password-length-block');
    var passwordValidationChr = document.getElementById('password-chr-block');
    var passwordValidationLengthIcon = $('#password-length-icon');
    var passwordValidationChrIcon = $('#password-chr-icon');

    if (pwdField.val().trim() === "")  {
        PasswordMgr.restart();
        errorsType.pwdEmpty = true;
        return false;
    } else {
        errorsType.pwdEmpty = false;
    }

    // Check length
    if (pwdField.val().length >= passwordConfig.minLength && pwdField.val().length <= passwordConfig.maxLength) {
        errorsType.minMaxMismatch = false
    } else {
        passwordValidationLength.classList.remove("fro-password-policy__block--success");
        passwordValidationLengthIcon.text("xmark");
        errorsType.minMaxMismatch = true;
        valid = false
    }

    // Check characters
    if (
        PasswordMgr.checkMatch(pwdField.val(), passwordConfig.minUpperCase, upperCaseLetters) &&
        PasswordMgr.checkMatch(pwdField.val(), passwordConfig.minLowerCase, lowerCaseLetters) &&
        PasswordMgr.checkMatch(pwdField.val(), passwordConfig.minNumber, numbers) &&
        PasswordMgr.checkMatch(pwdField.val(), passwordConfig.minSpecialChr, specialChr)
    ) {
        errorsType.patternNotValid = false;
    } else {
        errorsType.patternNotValid = true;
        passwordValidationChr.classList.remove("fro-password-policy__block--success");
        passwordValidationChrIcon.text("xmark");
        valid = false
    }

    var pass = pwdField.val();
    var notAllowedChar = pass.replace( allowedCharRegex, '' );
    // Check invalid characters
    if (!notAllowedChar || notAllowedChar.length === 0) {
        errorsType.invalidCharPresent = null;
    }else{
        errorsType.invalidCharPresent = notAllowedChar;
        passwordValidationChr.classList.remove("fro-password-policy__block--success");
        passwordValidationChrIcon.text("xmark");
        valid = false
    }
    return valid;
}

/**
 * Function to validate against regex pattern.
 */
PasswordMgr.checkMatch = function(_password, limit, pattern) {
    if (!limit || (_password.match(pattern)?.length >= limit)) {
        return true;
    } else {
        return false;
    }
}

PasswordMgr.hidePasswordValidationStatus = function() {
    var password_error_msg = $("#password-error-msg");

    password_error_msg.hide();
}

PasswordMgr.getErrorsType = function () {
    return errorsType;
}